import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './account/auth/gaurd/auth.gaurd';

const routes: Routes = [
  // { path: '', redirectTo: 'portal/dashboard', pathMatch: 'full' },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule), //Lazy load home module
    // data: { preload: true },
  },
  {
    path: 'account',
    loadChildren: () => import('./account/account.module').then((m) => m.AccountModule), //Lazy load account module
    // data: { preload: true },
  },
  {
    path: 'portal',
    loadChildren: () => import('./admin/admin.module').then((m) => m.AdminModule), //Lazy load account module
    // data: { preload: true },
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
